import { Helmet } from 'react-helmet-async'

const defaults = {
  siteName: 'Petite Palate',
  siteUrl: 'https://petitepalate.com.au',
  defaultTitle: 'Petite Palate | Curated Sensory Teethers',
  defaultDescription: 'Premium sensory teethers shaped like real first foods — apple, banana, and carrot. Designed around oral exploration science with graduated textures. Australian owned.',
  defaultImage: '/og-image.jpg',
}

export default function SEO({
  title,
  description,
  image,
  url,
  type = 'website',
  noindex = false
}) {
  const pageTitle = title
    ? `${title} | ${defaults.siteName}`
    : defaults.defaultTitle
  const pageDescription = description || defaults.defaultDescription
  const pageImage = image || defaults.defaultImage
  const pageUrl = url ? `${defaults.siteUrl}${url}` : defaults.siteUrl

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:site_name" content={defaults.siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />

      {/* Canonical */}
      <link rel="canonical" href={pageUrl} />
    </Helmet>
  )
}
